import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

interface OnboardingInputProps {
  label: string
  value: string
  placeholder?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  type?: string
  readOnly?: boolean
  name?: string
}

const OnboardingInput: React.FC<OnboardingInputProps> = ({
  label,
  value,
  placeholder,
  onChange,
  type = 'text',
  readOnly = false,
  name,
}) => {
  return (
    <div className={css(styles.container)}>
      <label className={css(styles.label)} htmlFor={name}>
        {label}
      </label>
      <input
        className={css(styles.input)}
        id={name}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        readOnly={readOnly}
      />
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: 4,
  },
  label: {
    fontSize: 'clamp(13px, 1.2vw, 16px)',
    fontWeight: 500,
    color: '#1E293B',
    marginBottom: 'clamp(6px, 1vw, 12px)',
  },
  input: {
    border: '1px solid #E5E7EB',
    outline: 'none',
    borderRadius: 8,
    background: '#F6F8FB',
    padding: 'clamp(10px, 1.5vw, 18px) clamp(12px, 1.5vw, 16px)',
    fontSize: 'clamp(14px, 1.5vw, 16px)',
    color: '#6B7280',
    fontWeight: 400,
    '::placeholder': {
      color: '#9CA3AF',
      fontWeight: 400,
    },
    boxShadow: 'none',
    marginBottom: 0,
    height: '38px',
    width: '100%',
  },
})

export default OnboardingInput
export { styles as onboardingInputStyles }
